import { addDoc, collection, deleteDoc, doc, getDoc, serverTimestamp, setDoc, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
const WHATSAPP_SENDER_FIELDS = [
    "id",
    "path",
    "metaPhoneNumberId",
    "businessPhoneNumber",
    "wabaId",
    "companyId",
    "agentId",
    "metaEntity",
    "status",
    "createdAt",
    "updatedAt",
];
const whatsappSenderConverter = {
    toFirestore(value) {
        const { id: _id, path: _path, ...data } = value;
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        warnUnknownFields("packages/ui WhatsappSender.fromFirestore", data, WHATSAPP_SENDER_FIELDS);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            metaPhoneNumberId: snapshot.id,
            businessPhoneNumber: data.businessPhoneNumber ?? "",
            wabaId: data.wabaId ?? null,
            companyId: data.companyId ?? "",
            agentId: data.agentId ?? null,
            metaEntity: data.metaEntity,
            status: data.status === "disabled" ? "disabled" : "active",
            createdAt: data.createdAt?.toDate?.() ?? data.createdAt ?? null,
            updatedAt: data.updatedAt?.toDate?.() ?? data.updatedAt ?? null,
        };
    },
};
export function whatsappSendersCollection(db) {
    return collection(db, "whatsappSenders").withConverter(whatsappSenderConverter);
}
export async function saveWhatsappSender(db, data, originalMetaPhoneNumberId) {
    const targetRef = doc(collection(db, "whatsappSenders"), data.metaPhoneNumberId);
    const existingId = originalMetaPhoneNumberId ?? data.metaPhoneNumberId;
    const existing = await getDoc(targetRef);
    await setDoc(targetRef, {
        ...data,
        ...(!existing.exists() ? { createdAt: serverTimestamp() } : {}),
        updatedAt: serverTimestamp(),
    }, { merge: true });
    if (existingId !== data.metaPhoneNumberId) {
        await deleteDoc(doc(whatsappSendersCollection(db), existingId));
    }
}
export async function deleteWhatsappSender(db, metaPhoneNumberId) {
    await deleteDoc(doc(whatsappSendersCollection(db), metaPhoneNumberId));
}
export async function createWhatsappTemplateMessage(db, sender, toWaId, templateName, requestNumber) {
    if (templateName === "request_acknowledgement" && !requestNumber) {
        throw new Error("requestNumber is required for request_acknowledgement");
    }
    const message = await addDoc(collection(db, "whatsappMessages"), {
        direction: "outbound",
        channel: "whatsapp",
        source: "developer_test",
        companyId: sender.companyId,
        agentId: sender.agentId ?? null,
        businessPhoneNumber: sender.businessPhoneNumber,
        metaPhoneNumberId: sender.metaPhoneNumberId,
        metaEntity: sender.metaEntity,
        toWaId,
        template: {
            name: templateName,
            languageCode: "en_US",
            parameters: templateName === "request_acknowledgement" ? [requestNumber] : [],
        },
        status: "pending_send",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });
    return message.id;
}
